import React, { Component } from "react";
import { Route, Redirect, Switch, BrowserRouter } from "react-router";
import Layout from "./components/Layout";
import Home from "./pages/course/Home/Home";
import { Counter } from "./components/Counter";
import Result from "./pages/results/Results";
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from "react-dom/server";

import Chat from "./pages/Chat/Chat";
import Course from "./pages/course/Course";
import ScheduleDetailed from "./pages/student_schedule/DetailedSchedule";
import Transcript from "./pages/Transcript/Transcript";
import Login from "./components/Login";
import Members from "./pages/course/Members/Members";
import Community from "./pages/course/Community/Community";
import Index from "./pages/Index";
import globalTranslations from "./global.json";
import Index2 from "./pages/course/E-Learning/Index";
import Axios from "axios";
import { GetServices } from "./GeneralAPI";
import Clinic from "./pages/Clinic/Clinic";
import GeneralSchedule from "./pages/student_schedule/GenearalSchedule/GeneralSchedule";
import Schedule from "./pages/student_schedule/Schedule";
import News from "./pages/News/News";
import HomePage from "./pages/Home/HomePage";
import Books from "./pages/course/Books/Books";
import StudentApp from "./pages/StudentApp";
import NotificationPage from './pages/Notifications/NotificationPage';
import Vaccine from "./pages/Vaccine/Vaccine";
import IdCheck from "./pages/Id/Id";
import SystemUpdates from "./pages/SystemMessages/SystemUpdates";
import ServiceAccess_StudentApp from "./pages/ServiceAccess/ServiceAccess_StudentApp";

class App extends Component {
    static displayName = App.name;

    //checkVaccineAnswered = (data2) => {

    //    fetch("api/Login/CheckVaccine")
    //        .then(response => response.text())
    //        .then(data => {
    //            if (data === "-1") {
    //                //window.location.href = "/Login"
    //                //this.props.history.push('/Login');
    //                //this.props.history.push('/dashboard');
    //                window.stopLoading();
    //                if (!window.location.href.includes("vaccine"))

    //                    window.location.href = "vaccine";


    //            }  else {



    //                this.setState({ isLogin: true, ID: data2, isLoading: false });
    //                window.stopLoading();
    //                if (window.location.href.includes("vaccine"))

    //                    window.location.href = "";




    //                return;
    //            }
    //        });

    //}


    checkIdAnswered = (data2) => {

        fetch("api/General/CheckNatId")
            .then(response => response.json())
            .then(data => {
                //window.location.href = "/Login"
                //this.props.history.push('/Login');
                //this.props.history.push('/dashboard');
                window.stopLoading();
                if (data["type"] == -1) {
                    this.setState({ isLogin: true, ID: data2, isLoading: false });
                    window.stopLoading();
                    //window.location.href = "";
                    return;
                }
                if (data["idNumber"].length < 5) {

                    if (!window.location.href.includes("IdCheck"))
                        window.location.href = "IdCheck";
                } else {
                    this.setState({ isLogin: true, ID: data2, isLoading: false });
                    window.stopLoading();
                    if (window.location.href.includes("IdCheck"))

                        window.location.href = "";
                    return;
                }




            });

        //fetch("api/General/CheckNatId")
        //    .then(response => response.text())
        //    .then(data => {
        //        if (data["Type"] === 7 && data["IdNumber"].length < 14) {

        //        } else if (data["Type"] === 1 && data["IdNumber"].length < 4) {

        //        } else {
        //        }
        //        if (data === "-1") {
        //            this.setState({ isLogin: false, ID: -1, isLoading: false });
        //            window.location.href = "Login";
        //            //window.location.href = "/Login"
        //            //this.props.history.push('/Login');
        //            //this.props.history.push('/dashboard');
        //            window.stopLoading();
        //        } else {
        //            this.checkVaccineAnswered(data);

        //        }
        //    });

    }
    constructor(props) {
        super(props);
        this.state = { isLogin: false, ID: -1, isLoading: true, forms: [] };
        if (!window.location.href.toLowerCase().includes("login"))
            fetch("api/Login/Check")
                .then(response => response.text())
                .then(data => {
                    if (data === "-1") {
                        this.setState({ isLogin: false, ID: -1, isLoading: false });
                        window.location.href = "Login";
                        //window.location.href = "/Login"
                        //this.props.history.push('/Login');
                        //this.props.history.push('/dashboard');
                        window.stopLoading();
                    } else {
                        this.checkIdAnswered(data);

                    }
                });


        else {
            window.stopLoading();
        }
        this.props.initialize({
            languages: [
                {
                    name: "English",
                    code: "en",
                    icon: "flag-icon flag-icon-gb",
                    dir: "ltr"
                },

                {
                    name: "العربية",
                    code: "ar",
                    icon: "flag-icon flag-icon-eg",
                    dir: "rtl"
                }

                // {
                //   name: "Français",
                //   code: "fr",
                //   icon: "flag-icon flag-icon-fr",
                //   dir: "ltr"
                // }
            ],
            translation: globalTranslations,

            options: { renderToStaticMarkup }
        });
        GetServices().then(x => {
            this.setState({ forms: x });
        });
    }
    login = username => {
        if (username > 0) window.location.href = "";
    };

    render() {
        return (
            <React.Fragment>
                {this.state.forms.map(item => {
                    return <span dangerouslySetInnerHTML={{ __html: item.formString }} />;
                })}

                <Switch>
                    <Route
                        path="/login"
                        render={props => (
                            <Login
                                {...props}
                                Login={this.login}
                                isLogin={this.state.isLogin}
                            />
                        )}
                    />

                    <Route
                        path="/vaccine"
                        render={props => (
                            <Vaccine
                                {...props}
                                Login={this.login}
                                isLogin={this.state.isLogin}
                            />
                        )}
                    />
                    <Route
                        path="/IdCheck"
                        render={props => (
                            <IdCheck
                                {...props}
                                Login={this.login}
                                isLogin={this.state.isLogin}
                            />
                        )}
                    />
                    <Route
                        path="/systemupdates"
                        render={props => (
                            <SystemUpdates
                                {...props}
                                Login={this.login}
                                isLogin={this.state.isLogin}
                            />
                        )}
                    />
                    <Layout
                        services={this.state.forms}
                        ID={this.state.ID}
                        isLogin={this.state.isLogin}
                    >
                        <Route path="/course/">
                            <React.Fragment>
                                <Route
                                    path="/"
                                    exact
                                    render={props => <HomePage {...props} ID={this.state.ID} />}
                                />
                                <Route
                                    path="/home"
                                    render={props => <HomePage {...props} ID={this.state.ID} />}
                                />
                                <Route path="/course/:crsnum" component={Course} />
                                <Route path="/notification/:id" component={NotificationPage} />

                                <Route path="/course/:crsnum/" exact component={Home} />

                                <Route path="/course/:crsnum/Members" component={Members} />
                                <Route path="/course/:crsnum/ELearning" component={Index2} />
                                <Route path="/course/:crsnum/community" component={Community} />
                                <Route path="/course/:crsnum/Books" component={Books} />

                                <Route path="/Results/:batchNum?" component={Result} />
                                <Route path="/chatservice/:regnum?" component={Chat} />

                                {/* <Route
                  path="/StudentApp.aspx"
                  exact
                  render={props => <HomePage {...props} ID={this.state.ID} />}
                /> */}
                                <Route
                                    path="/StudentApp.aspx/:itemCode"
                                    exact
                                    component={StudentApp}
                                />

                                <Route
                                    path="/ServiceAccess/StudentApp.aspx/:itemCode"
                                    exact
                                    component={ServiceAccess_StudentApp}
                                />

                                <Route path="/Transcript" component={Transcript} />
                                <Route path="/Clinic" component={Clinic} />

                                <Route path="/schedule/" component={Schedule} />
                                <Route
                                    path="/Schedule/Weekly/:weekNo?"
                                    component={ScheduleDetailed}
                                />
                                <Route path="/Schedule/General" component={GeneralSchedule} />

                                <Route path="/News" component={News} />

                                <Route path="/counter/:id?" component={Counter} />
                            </React.Fragment>
                        </Route>
                    </Layout>
                </Switch>
            </React.Fragment>
        );
    }
}
export default withLocalize(App);



// WEBPACK FOOTER //
// ./src/App.js